export const nameValidator = /^[a-zA-Z\s-']+$/;

export const emailValidator =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;

export const dateOfBirthValidator = /^\d{2}\/\d{2}\/\d{4}$/;

export const ssnValidator = /^\d{3}-\d{2}-\d{4}$/;
